import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import logo from '@/assets/logo.svg';
import { RouteFallback } from '@/components/ui/RouteFallback';
import { useI18n } from '@/hooks/useI18n';

export const AuthLayout = () => {
  const { t } = useI18n();

  return (
    <div className="auth-page u137-login">
      <section className="auth-brand u137-brand">
        <div className="u137-logo-row">
          <img className="auth-logo" src={logo} alt={t('brand.name')} />
        </div>
        <span className="u137-brand-mark">{t('auth.brandMark')}</span>
        <p>{t('auth.brandText')}</p>
        <div className="auth-proof u137-proof">
          <span>{t('auth.proof1')}</span>
          <span>{t('auth.proof2')}</span>
          <span>{t('auth.proof3')}</span>
        </div>
      </section>
      <section className="auth-card-wrap u137-card-wrap">
        <Suspense fallback={<RouteFallback />}>
          <Outlet />
        </Suspense>
      </section>
    </div>
  );
};
